.root {
  font: var(--type-label-md);
  letter-spacing: var(--tracking-label-md);
  display: inline-flex;
  align-items: center;
  padding: var(--space-1) var(--space-3);
  border-radius: var(--shape-xs);
  font-weight: 600;
  white-space: nowrap;
  background-color: var(--sign-type-default);
  color: var(--md-on-surface);
}

.livestream {
  background: var(--sign-type-livestream);
}

.goldText {
  background-image: var(--sign-type-livestream-text);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.coloured {
  color: var(--on-sign-type);
}
